import { Button, FormGroup, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { useGetMyServiceList } from "src/hooks/api/product/useGetMyServiceList";
import { useModal } from "src/hooks/useModal";
import { restartSubscription } from "src/service/pay";
import { getProductFromSessionStorage } from "src/utils/storage/auth";

const ReSubscribeModal = () => {
  const { isResumeSubscription, setResumeSubscription } = useModal();
  const { t } = useTranslation();
  const openModal = () => {
    setResumeSubscription(true);
  };
  const hideModal = () => {
    setResumeSubscription(false);
  };
  const { serviceList } = useGetMyServiceList({});
  return (
    <Modal
      // show={modal.modalSubscriptionsActivate}
      show={isResumeSubscription}
      onHide={hideModal}
      className="confirm__period"
      style={{ opacity: 1 }}
    >
      <Modal.Header>
        <Modal.Title>{"구독 재개하기"}</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <FormGroup className="mg mb-0">
          {
            "정기결제가 즉시 진행되며, 등록된 카드로 결제됩니다. 신중하게 확인해 주세요."
          }
        </FormGroup>
      </Modal.Body>
      <Modal.Footer>
        <Button className="btn btn-gray" onClick={hideModal}>
          {t("common.cancelBtn")}
        </Button>
        <Button
          className="btn btn-green"
          onClick={() =>
            restartSubscription({
              product: getProductFromSessionStorage(),
              serviceBillUid: serviceList[0].serviceBillUid,
            })
          }
        >
          {"결제 진행"}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ReSubscribeModal;
